import type {
  CreateReceiptUploadInput,
  CreateReimbursementTransactionInput,
  UpdateReimbursementTransactionInput,
} from 'CDK_API';
import type { ReceiptUpload, ReimbursementTransactionStatus } from 'API';
import { reimbursementsService } from './reimbursements.service';

/* Using v2Reimbursements CDK Lambda to get reimbursement transaction */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getReimbursementTransaction = async (id: string): Promise<any> => {
  return reimbursementsService.getReimbursementTransaction({ id });
};

/* Using v2Reimbursements CDK Lambda to create reimbursement transaction */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createReimbursementTransaction = async (
  input: CreateReimbursementTransactionInput
): Promise<any> => {
  return reimbursementsService.createReimbursementTransaction(input);
};

/* Using v2Reimbursements CDK Lambda to update reimbursement transaction */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const updateReimbursementTransaction = async (
  input: UpdateReimbursementTransactionInput
): Promise<any> => {
  return reimbursementsService.updateReimbursementTransaction(input);
};

/* Using v2Reimbursements CDK Lambda to get receipt upload */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getReceiptUpload = async (id: string): Promise<any> => {
  return reimbursementsService.getReceiptUpload({ id });
};

/* Using v2Reimbursements CDK Lambda to create receipt upload */
export const createReceiptUpload = async (input: CreateReceiptUploadInput): Promise<ReceiptUpload> => {
  return reimbursementsService.createReceiptUpload(input) as unknown as ReceiptUpload;
};

/* Using v2Reimbursements CDK Lambda to get reimbursements */
export const getReimbursementTransactionsByPaidolId = async (
  paidolId: string,
  status: ReimbursementTransactionStatus | string,
  paidolUserId?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<any> => {
  return reimbursementsService.getReimbursementTransactionsByPaidolId({
    paidolId,
    status: status as any,
    paidolUserId,
  });
};

/* Using v2Reimbursements CDK Lambda to delete TransactionToReceiptUpload records */
export const deleteTransactionToReceiptUpload = async (receiptUploadId: string) => {
  // Validate receiptUploadId before making the request
  if (!receiptUploadId || typeof receiptUploadId !== 'string' || receiptUploadId.trim() === '') {
    const error = new Error(
      `receiptUploadId is required and cannot be empty. Received: ${receiptUploadId} (type: ${typeof receiptUploadId})`
    );
    // eslint-disable-next-line no-console
    console.error('[reimbursementService] Invalid receiptUploadId:', receiptUploadId);
    throw error;
  }

  const validReceiptUploadId = String(receiptUploadId).trim();
  const payload = await reimbursementsService.deleteTransactionToReceiptUpload({
    receiptUploadId: validReceiptUploadId,
  });

  if (!payload.success) {
    // eslint-disable-next-line no-console
    console.error('[reimbursementService] Delete operation failed:', payload.message || 'Unknown error');
    throw new Error(payload.message || 'Failed to delete TransactionToReceiptUpload records');
  }

  return payload;
};
